/**
 * Created by comoon on 2/27/16.
 */


var WalleA = {
    code: "A",
    name: "准AA行程"
};

var WalleB = {
    code: "B",
    name: "准AB行程"
};

var WalleC = {
    code: "C",
    name: "准AC行程"
};
module.exports = {
    WalleA,
    WalleB,
    WalleC,
    list: [WalleA, WalleB, WalleC]
};


/** WEBPACK FOOTER **
 ** ./script/conf/trip-type.js
 **/